import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Video, Mail, LogOut, ExternalLink, Users, UserCircle, MessageCircleHeart, MessageSquare } from "lucide-react";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/webinars", label: "Webinars", icon: Video },
  { to: "/admin/campaigns", label: "Campaigns", icon: Mail },
  { to: "/admin/community", label: "Community", icon: MessageCircleHeart },
  { to: "/admin/messages", label: "Messages", icon: MessageSquare },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F3F4F6] flex">
      {/* Sidebar */}
      <aside className="w-60 bg-white border-r border-[#E5E7EB] flex flex-col fixed h-full">
        <div className="h-16 flex items-center px-6 border-b border-[#E5E7EB]">
          <img src="/upwardcast-logo-transparent.png" alt="UpwardCast" className="h-7 w-auto" />
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-semibold transition-colors ${
                  isActive ? "bg-[#6D28B5] text-white" : "text-[#4B5563] hover:bg-[#F3F4F6]"
                }`
              }
            >
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
          {user?.role === "admin" && (
            <NavLink
              to="/admin/users"
              data-testid="nav-users"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-semibold transition-colors ${
                  isActive ? "bg-[#6D28B5] text-white" : "text-[#4B5563] hover:bg-[#F3F4F6]"
                }`
              }
            >
              <Users className="w-4 h-4" /> Users
            </NavLink>
          )}
          {user?.role === "admin" && (
            <NavLink
              to="/admin/team"
              data-testid="nav-hosts"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-semibold transition-colors ${
                  isActive ? "bg-[#6D28B5] text-white" : "text-[#4B5563] hover:bg-[#F3F4F6]"
                }`
              }
            >
              <UserCircle className="w-4 h-4" /> Hosts
            </NavLink>
          )}
          <NavLink
            to="/admin/profile"
            data-testid="nav-profile"
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 text-sm font-semibold transition-colors ${
                isActive ? "bg-[#6D28B5] text-white" : "text-[#4B5563] hover:bg-[#F3F4F6]"
              }`
            }
          >
            <UserCircle className="w-4 h-4" /> My profile
          </NavLink>
        </nav>
        <div className="p-3 border-t border-[#E5E7EB] space-y-1">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-3 py-2.5 text-sm font-semibold text-[#4B5563] hover:bg-[#F3F4F6]"
          >
            <ExternalLink className="w-4 h-4" /> View site
          </a>
          <button
            onClick={() => {
              logout();
              navigate("/admin/login");
            }}
            data-testid="logout-btn"
            className="w-full flex items-center gap-3 px-3 py-2.5 text-sm font-semibold text-[#4B5563] hover:bg-[#F3F4F6]"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
          <div className="px-3 pt-2 text-xs text-[#9CA3AF] truncate">{user?.email}</div>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 ml-60 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
